import { useStore } from "../../../contexts/store-provider";
import { observer } from "mobx-react";
import { ColumnType } from "../../../constants/enums/grid-column-type-enum";
import Grid, { getColumns } from "../../../shared-components/Grid/Grid";
import { IAgreementRecordHistoryList, IAgreementRecordVM } from "../../../models/response/ISMRResponse";
import { formatMessage } from "../../../translations/format-message";
import { useEffect } from "react";
import { generatePDF } from "../../../constants/constants";
import moment from "moment";

interface IProps {
  scrollToCard: (id: number) => void;
}

const SmrAgreementHistory = (props: IProps) => {
  const { smrStore } = useStore();
  const {
    salesAgreementRecordHistoryListState,
    allSalesAgreementRecordHistory,
    setSelectedBookingId,
    setDownloadAgreementPDFSMRId,
    GetSalesAgreementRecordStateBySMRIdService,
    downloadAgreementPDFSMRId,
    salesAgreementRecord,
    salesAgreementRecordDetail,
  } = smrStore;

  const agreementViewHandler = (row: IAgreementRecordHistoryList) => {
    props.scrollToCard(row.SMRId);
    setSelectedBookingId(row.SMRId);
  };

  useEffect(() => {
    if (
      downloadAgreementPDFSMRId > 0 &&
      salesAgreementRecord &&
      salesAgreementRecord.SMRId === downloadAgreementPDFSMRId
    ) {
      generatePDF(salesAgreementRecordDetail);
      setDownloadAgreementPDFSMRId(-1);
    }
  }, [salesAgreementRecord?.SMRId, downloadAgreementPDFSMRId]);

  const downloadClickHandler = async (row: IAgreementRecordHistoryList) => {
    // resetSalesAgreementRecordState();
    await GetSalesAgreementRecordStateBySMRIdService(row.SMRId);
    setDownloadAgreementPDFSMRId(row.SMRId);
    setSelectedBookingId(row.SMRId);
  };

  const addIcons: Array<any> = [
    {
      handler: agreementViewHandler,
      icon: <i className="bi bi-eye"></i>,
      key: "",
      title: "edit",
      className: "btn-primary btn-sm",
    },
    {
      handler: downloadClickHandler,
      icon: <i className="bi bi-download"></i>,
      key: "",
      title: "download",
      className: "btn-primary btn-sm",
    },
  ];

  const columArray: any = [
    {
      columnType: ColumnType.Hidden,
      accessorKey: "Id",
    },
    {
      columnType: ColumnType.TextHeader,
      accessorKey: "AgreementSignOffDate",
      displayName: "date",
    },
    {
      columnType: ColumnType.ActionsFormatter,
      icons: addIcons,
      displayName: "label_action",
    },
  ];
  const columns = getColumns<IAgreementRecordHistoryList, number>(columArray);

  return (
    <>
      <h3 className="mb-2">{formatMessage("agreement_history")}</h3>
      <div className="border">
        {allSalesAgreementRecordHistory?.length > 0 ? (
          <Grid
            data={allSalesAgreementRecordHistory}
            columns={columns}
            isInProgress={salesAgreementRecordHistoryListState.inProgress}
            hiddenColumns={["Id"]}
          />
        ) : (
          <h3 className="mt-2 text-center">{formatMessage("no_agreement")}</h3>
        )}
      </div>
    </>
  );
};

export default observer(SmrAgreementHistory);
